
var sprite = require("/tmp/build_27def88f/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 25 17\" id=\"icon_check_jax_e9b1384022d2bf12c5594e4a14cbb2d9\" > <path d=\"M23.569 1.29553L10.0958 14.7687L1.8003 6.47314\" stroke=\"#2CD4AE\" stroke-width=\"3\" fill=\"none\"/> </symbol>";
module.exports = sprite.add(image, "icon_check_jax_e9b1384022d2bf12c5594e4a14cbb2d9");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_check.svg
// module id = 1752
// module chunks = 1